const prefix = 'REACT_APP_'

declare global {
  interface Window {
    _env_: Record<string, string>
  }
}

function env(key: string, defaultValue?: string): string {
  const envVal =
    (process.env.NODE_ENV === 'development' ? process.env[`${prefix}${key}`] : window._env_[key]) || defaultValue
  if (!envVal) {
    throw new Error(`Environment variable ${key} missing with no default value`)
  }
  return envVal
}

export default {
  redirectBaseUrl: env('REDIRECT_BASE_URL', "https://cls-access-host2.cls-npn.mckinsey-solutions.com"),
  clientId: env('CLIENT_ID', "b3a85dd3-093a-4a1c-9860-5510259bff4e"),
  oidcConfigUrl: env('OIDC_CONFIG_URL', "https://auth.int.mckinsey.id/auth/realms/r/.well-known/openid-configuration"),
}
